import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({
	Open: { k: "search.save", v: "Save Search" },
	SaveSearchData: { k: "search.save", v: "Save" },
	UpdateSearchData: { k: "search.update", v: "Update" },
	Cancel: { k: "search.cancel", v: "Cancel" },
	SearchName: { k: "search.name", v: "Name *" },
	SearchDescription: { k: "search.description", v: "Description" }
});



// WEBPACK FOOTER //
// ./src/panels/saveSearch/SaveSearch.labels.ts